import { render } from "./MyMeetings.vue?vue&type=template&id=530b9f54&scoped=true"
import script from "./MyMeetings.vue?vue&type=script&lang=js"
export * from "./MyMeetings.vue?vue&type=script&lang=js"

import "./MyMeetings.vue?vue&type=style&index=0&id=530b9f54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530b9f54"]])

export default __exports__